"use client";
import Link from "next/link";

export default function ProgramCardComp({
  item,
  variant,
}: {
  item: any;
  variant: string;
}) {
  return (
    <div
      className={
        variant === "scroll"
          ? "flex-shrink-0 p-4 w-80 min-h-64 bg-white shadow-sm hover:shadow-md rounded-xl lg:rounded-2xl flex flex-col justify-center items-top cursor-pointer"
          : "bg-white shadow-sm hover:shadow-md rounded-xl lg:rounded-2xl p-4 cursor-pointer"
      }
    >
      <Link href={`/program/${item.name.replaceAll(" ", "-")}`}>
        <div className="text-left h-full">
          <img src={item.imageSrc} alt={item.name} className="w-10" />
          <p className="text-dark text-md font-semibold my-2">{item.name}</p>
          <p className="text-gray-500 text-sm">{item.description}</p>
        </div>
      </Link>
    </div>
  );
}
